import {CardHeaderToolbar, Pagination} from 'app/common/_partials/controls';
import paginationFactory, {PaginationProvider} from 'react-bootstrap-table2-paginator';
import {
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  defaultTableOptions,
  getHandlerTableChange,
} from 'app/common/_helpers';
import {useCallback, useEffect, useState} from 'react';
import {isEqual, isFunction} from 'lodash';
import BootstrapTable from 'react-bootstrap-table-next';
import {useDispatch, useSelector, shallowEqual} from 'react-redux';
import {getProductReportByPaginationAction, getProductReportNotByPaginationAction} from '../redux/reportActions';
import ProductReportViewFilter from './ProductReportViewFilter';
import {FormattedNumber} from 'react-intl';

export default function ProductReportView() {
  const dispatch = useDispatch();
  const [productReportByPagination, setProductReportByPagination] = useState([]);
  const [totalProductReportByPagination, settotalProductReportByPagination] = useState(0);
  const [totalQuantity, settotalQuantity] = useState([]);
  const [totalRevenue, settotalRevenue] = useState([]);

  const tableOptions = {
    ...defaultTableOptions,
    searchText: null,
  };
  const [queryParams, setQueryParamsBase] = useState(tableOptions);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }
      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);


  const productColumns = [
    {
      dataField: 'productName',
      text: 'Tên sản phẩm',
      footer: '',
      footerClasses: 'border-top',
    },
    {
      dataField: 'productCode',
      text: 'Mã sản phẩm',
      footer: '',
      footerClasses: 'border-top',
    },
    {
      dataField: 'quantity',
      text: 'Tổng khối lượng(kg)',
      footer: '',
      formatter: (cell) => {
        return (
          <span>
            <FormattedNumber value={cell?.toFixed(2)} />
          </span>
        );
      },
      footerClasses: 'border-top',
    },
    {
      dataField: 'discount',
      text: 'Giảm giá (VND)',
      footer: '',
      formatter: (cell) => {
        return (
          <span>
            <FormattedNumber value={cell} />
          </span>
        );
      },
      footerClasses: 'border-top',
    },
    {
      dataField: 'totalAmount',
      text: 'Tổng tiền (VND)',
      footer: '',
      formatter: (cell) => {
        return (
          <span>
            <FormattedNumber value={cell} />
          </span>
        );
      },
      footerClasses: 'border-top',
    },
  ];

  useEffect(() => {
    loadProductReportByPagination();
    loadproductReportNotByPaginationAction()
  }, [dispatch, queryParams]);

  const loadProductReportByPagination = () => {
    const params = {
      page: queryParams.pageNumber,
      pageSize: queryParams.pageSize,
      ...queryParams,
    }
    dispatch(getProductReportByPaginationAction(params)).then(res => {
      let productReports = res.data;
      if(productReports.length > 0) {
        productReports.map((productReport) => {
          setProductReportByPagination(productReport.data);
          settotalProductReportByPagination(productReport.count);
        })
      }else{
        settotalProductReportByPagination(0);
        setProductReportByPagination(null);
      }
    });
  };

  const loadproductReportNotByPaginationAction = () => {
    const params = {
      page: queryParams.pageNumber,
      pageSize: queryParams.pageSize,
      ...queryParams,
    }
    dispatch(getProductReportNotByPaginationAction(params)).then(res => {
      let productReports = res.data;
      let totalQuantityReport = 0;
      let totalRevenueReport = 0;
      if(productReports.length > 0) {
        productReports.map((productReport) => {
          totalQuantityReport += productReport.quantity;
          totalRevenueReport += productReport.totalAmount;
          settotalQuantity(totalQuantityReport);
          settotalRevenue(totalRevenueReport);
        })
      }else{
        settotalRevenue(0);
        settotalQuantity(0);
      }
    });
  }


  return (
    <>
      <div className='row'>
        <div className='col-xl-12'>
          <div className='card card-custom gutter-b'>
            <div className='container-full'>
              <h3 className='card-title font-weight-bolder text-dark'></h3>
              <CardHeaderToolbar>
                <div className='d-flex'>
                  <ProductReportViewFilter setQueryParams={setQueryParams} queryParams={queryParams} />
                </div>
              </CardHeaderToolbar>
            </div>
            <div className='container-full'>
              <h3 className='card-title font-weight-bolder text-dark'></h3>
              <div className='row d-flex customer report'>
                <div className='col-md-4 d-flex align-items-center justify-content-center'>
                  <div>Tổng số sản phẩm:</div>
                  <div className='ms-4'>{totalProductReportByPagination}</div>
                </div>
                <div className='col-md-4 d-flex align-items-center justify-content-center'>
                  <div>Tổng số lượng (kg):</div>
                  <div className='ms-4'>{totalQuantity.toLocaleString()}</div>
                </div>
                <div className='col-md-4 d-flex align-items-center justify-content-center'>
                  <div>Tổng doanh thu (VND):</div>
                  <div className='ms-4'>{totalRevenue.toLocaleString()}</div>
                </div>
              </div>
            </div>
            <div className='card-body'>
              <PaginationProvider
                pagination={paginationFactory({
                  ...tableOptions,
                  totalSize: totalProductReportByPagination,
                  page: queryParams.pageNumber,
                  withFirstAndLast: false,
                  hideSizePerPage: true,
                })}
              >
                {({paginationProps, paginationTableProps}) => {
                  return (
                    <Pagination isLoading={false} paginationProps={paginationProps}>
                      <BootstrapTable
                        wrapperClasses='table-responsive'
                        classes='table-sm table-row-bordered table-head-custom table-vertical-center overflow-hidden'
                        bootstrap4
                        remote
                        hover
                        keyField='_id'
                        onTableChange={getHandlerTableChange(setQueryParams)}
                        data={productReportByPagination === null ? [] : productReportByPagination}
                        columns={productColumns}
                        {...paginationTableProps}
                      >
                        <PleaseWaitMessage entities={productReportByPagination === null ? [] : productReportByPagination} />
                        <NoRecordsFoundMessage entities={productReportByPagination === null ? [] : productReportByPagination} />
                      </BootstrapTable>
                    </Pagination>
                  );
                }}
              </PaginationProvider>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}